import React from "react"


const Datenschutz: React.FC = () => {
    return (
        <div className="max-w-3xl mx-auto px-4 py-10 space-y-6 text-gray-800">
            <h1 className="text-3xl font-bold">Datenschutzerklärung</h1>

            <section>
                <h2 className="text-2xl font-semibold mb-2">Präambel</h2>
                <p>Mit der folgenden Datenschutzerklärung möchten wir Sie darüber aufklären, welche Arten Ihrer
                    personenbezogenen Daten
                    (nachfolgend auch kurz als "Daten" bezeichnet) wir zu welchen Zwecken und in welchem Umfang im Rahmen der
                    Bereitstellung
                    unserer Applikation verarbeiten.
                </p>
                <p>Die verwendeten Begriffe sind nicht geschlechtsspezifisch.</p>
                <p>Stand: 2. August 2025</p>
            </section>

            <section>
                <h2 className="text-2xl font-semibold mb-2">Inhaltsübersicht</h2>
                <ul className="index space-y-1">
                    <li><a className="index-link" href="#m4158">Präambel</a></li>
                    <li><a className="index-link" href="#m3">Verantwortlicher</a></li>
                    <li><a className="index-link" href="#mOverview">Übersicht der Verarbeitungen</a></li>
                    <li><a className="index-link" href="#m2427">Maßgebliche Rechtsgrundlagen</a></li>
                    <li><a className="index-link" href="#m27">Sicherheitsmaßnahmen</a></li>
                    <li><a className="index-link" href="#m12">Allgemeine Informationen zur Datenspeicherung und Löschung</a></li>
                    <li><a className="index-link" href="#m225">Bereitstellung des Onlineangebots und Webhosting</a></li>
                    <li><a className="index-link" href="#m15">Änderung und Aktualisierung</a></li>
                    <li><a className="index-link" href="#m42">Begriffsdefinitionen</a></li>
                </ul>
            </section>

            <section>
                <h2 className="text-2xl font-semibold mb-2">Verantwortlicher</h2>
                <p><strong>Name:</strong> Sebastian Feustel</p>
                <p><strong>E-Mail-Adresse: </strong><a
                    href="mailto:dinofind@hackwiki.de">dinofind@hackwiki.de</a></p>
            </section>

            <section>
                <h2 className="text-2xl font-semibold mb-2">Übersicht der Verarbeitungen</h2>
                <p>Die nachfolgende Übersicht fasst die Arten der verarbeiteten Daten und die Zwecke ihrer Verarbeitung zusammen
                    und
                    verweist auf die betroffenen Personen.</p>

                <h3>Arten der verarbeiteten Daten</h3>
                <ul className="space-y-1">
                    <li>Nutzungsdaten.</li>
                    <li>Meta-, Kommunikations- und Verfahrensdaten.</li>
                    <li>Protokolldaten.</li>
                </ul>

                <h3>Kategorien betroffener Personen</h3>
                <ul className="space-y-1">
                    <li>Nutzer.</li>
                </ul>

                <h3>Zwecke der Verarbeitung</h3>
                <ul className="space-y-1">
                    <li>Sicherheitsmaßnahmen.</li>
                    <li>Bereitstellung unseres Onlineangebotes und Nutzerfreundlichkeit.</li>
                    <li>Informationstechnische Infrastruktur.</li>
                </ul>
            </section>

            <section>
                <h2 className="text-2xl font-semibold mb-2">Maßgebliche Rechtsgrundlagen</h2>
                <p><strong>Maßgebliche Rechtsgrundlagen nach der DSGVO: </strong>Im Folgenden erhalten Sie eine Übersicht der
                    Rechtsgrundlagen der DSGVO, auf deren Basis wir personenbezogene Daten verarbeiten. Bitte nehmen Sie zur
                    Kenntnis,
                    dass neben den Regelungen der DSGVO nationale Datenschutzvorgaben in Ihrem bzw. unserem Wohn- oder Sitzland
                    gelten
                    können. Sollten ferner im Einzelfall speziellere Rechtsgrundlagen maßgeblich sein, teilen wir Ihnen diese in
                    der
                    Datenschutzerklärung mit.</p>
                <ul className="space-y-1">
                    <li><strong>Berechtigte Interessen (Art. 6 Abs. 1 S. 1 lit. f) DSGVO)</strong> - die Verarbeitung ist zur
                        Wahrung
                        der berechtigten Interessen des Verantwortlichen oder eines Dritten notwendig, vorausgesetzt, dass die
                        Interessen, Grundrechte und Grundfreiheiten der betroffenen Person, die den Schutz personenbezogener
                        Daten
                        verlangen, nicht überwiegen.
                    </li>
                </ul>
                <p><strong>Nationale Datenschutzregelungen in Deutschland: </strong>Zusätzlich zu den Datenschutzregelungen der
                    DSGVO
                    gelten nationale Regelungen zum Datenschutz in Deutschland. Hierzu gehört insbesondere das Gesetz zum Schutz
                    vor
                    Missbrauch personenbezogener Daten bei der Datenverarbeitung (Bundesdatenschutzgesetz – BDSG). Das BDSG
                    enthält
                    insbesondere Spezialregelungen zum Recht auf Auskunft, zum Recht auf Löschung, zum Widerspruchsrecht, zur
                    Verarbeitung besonderer Kategorien personenbezogener Daten, zur Verarbeitung für andere Zwecke und zur
                    Übermittlung
                    sowie automatisierten Entscheidungsfindung im Einzelfall einschließlich Profiling. Ferner können
                    Landesdatenschutzgesetze der einzelnen Bundesländer zur Anwendung gelangen.
                </p>
            </section>

            <section>
                <h2 className="text-2xl font-semibold mb-2">Sicherheitsmaßnahmen</h2>
                <p>Wir treffen nach Maßgabe der gesetzlichen Vorgaben unter Berücksichtigung des Stands der Technik, der
                    Implementierungskosten und der Art, des Umfangs, der Umstände und der Zwecke der Verarbeitung sowie der
                    unterschiedlichen Eintrittswahrscheinlichkeiten und des Ausmaßes der Bedrohung der Rechte und Freiheiten
                    natürlicher
                    Personen geeignete technische und organisatorische Maßnahmen, um ein dem Risiko angemessenes Schutzniveau zu
                    gewährleisten.</p>
                <p>Zu den Maßnahmen gehören insbesondere die Sicherung der Vertraulichkeit, Integrität und Verfügbarkeit von
                    Daten
                    durch
                    Kontrolle des physischen und elektronischen Zugangs zu den Daten als auch des sie betreffenden Zugriffs, der
                    Eingabe, der Weitergabe, der Sicherung der Verfügbarkeit und ihrer Trennung. Des Weiteren haben wir
                    Verfahren
                    eingerichtet, die eine Wahrnehmung von Betroffenenrechten, die Löschung von Daten und Reaktionen auf die
                    Gefährdung
                    der Daten gewährleisten. Ferner berücksichtigen wir den Schutz personenbezogener Daten bereits bei der
                    Entwicklung
                    bzw. Auswahl von Hardware, Software sowie Verfahren entsprechend dem Prinzip des Datenschutzes, durch
                    Technikgestaltung und durch datenschutzfreundliche Voreinstellungen.</p>
                <p>Sicherung von Online-Verbindungen durch TLS-/SSL-Verschlüsselungstechnologie (HTTPS): Um die Daten der
                    Nutzer,
                    die
                    über unsere Online-Dienste übertragen werden, vor unerlaubten Zugriffen zu schützen, setzen wir auf die
                    TLS-/SSL-Verschlüsselungstechnologie. Secure Sockets Layer (SSL) und Transport Layer Security (TLS) sind die
                    Eckpfeiler der sicheren Datenübertragung im Internet. Diese Technologien verschlüsseln die Informationen,
                    die
                    zwischen der Website oder App und dem Browser des Nutzers (oder zwischen zwei Servern) übertragen werden,
                    wodurch
                    die Daten vor unbefugtem Zugriff geschützt sind. TLS, als die weiterentwickelte und sicherere Version von
                    SSL,
                    gewährleistet, dass alle Datenübertragungen den höchsten Sicherheitsstandards entsprechen. Wenn eine Website
                    durch
                    ein SSL-/TLS-Zertifikat gesichert ist, wird dies durch die Anzeige von HTTPS in der URL signalisiert. Dies
                    dient
                    als
                    ein Indikator für die Nutzer, dass ihre Daten sicher und verschlüsselt übertragen werden.</p>
            </section>

            <section>
                <h2 className="text-2xl font-semibold mb-2">Allgemeine Informationen zur Datenspeicherung und Löschung</h2>
                <p>Wir löschen personenbezogene Daten, die wir verarbeiten, gemäß den gesetzlichen Bestimmungen, sobald die
                    zugrundeliegenden Einwilligungen widerrufen werden oder keine weiteren rechtlichen Grundlagen für die
                    Verarbeitung
                    bestehen. Dies betrifft Fälle, in denen der ursprüngliche Verarbeitungszweck entfällt oder die Daten nicht
                    mehr
                    benötigt werden. Ausnahmen von dieser Regelung bestehen, wenn gesetzliche Pflichten oder besondere
                    Interessen
                    eine
                    längere Aufbewahrung oder Archivierung der Daten erfordern.</p>
                <p>Insbesondere müssen Daten, die aus handels- oder steuerrechtlichen Gründen aufbewahrt werden müssen oder
                    deren
                    Speicherung notwendig ist zur Rechtsverfolgung oder zum Schutz der Rechte anderer natürlicher oder
                    juristischer
                    Personen, entsprechend archiviert werden.</p>
                <p>Unsere Datenschutzhinweise enthalten zusätzliche Informationen zur Aufbewahrung und Löschung von Daten, die
                    speziell
                    für bestimmte Verarbeitungsprozesse gelten.</p>
                <p>Bei mehreren Angaben zur Aufbewahrungsdauer oder Löschungsfristen eines Datums, ist stets die längste Frist
                    maßgeblich. Daten, die nicht mehr für den ursprünglich vorgesehenen Zweck, sondern aufgrund gesetzlicher
                    Vorgaben
                    oder anderer Gründe aufbewahrt werden, verarbeiten wir ausschließlich zu den Gründen, die ihre Aufbewahrung
                    rechtfertigen.</p>
                <p>Aufbewahrung und Löschung von Daten: Die folgenden allgemeinen Fristen gelten für die Aufbewahrung und
                    Archivierung
                    nach deutschem Recht:</p>
                <ul className="space-y-1">
                    <li>10 Jahre - Aufbewahrungsfrist für Bücher und Aufzeichnungen, Jahresabschlüsse, Inventare, Lageberichte,
                        Eröffnungsbilanz sowie die zu ihrem Verständnis erforderlichen Arbeitsanweisungen und sonstigen
                        Organisationsunterlagen (§ 147 Abs. 1 Nr. 1 i.V.m. Abs. 3 AO, § 14b Abs. 1 UStG, § 257 Abs. 1 Nr. 1
                        i.V.m.
                        Abs.
                        4 HGB).</li>
                    <li>8 Jahre - Buchungsbelege, wie z. B. Rechnungen und Kostenbelege (§ 147 Abs. 1 Nr. 4 und 4a i.V.m. Abs. 3
                        Satz 1
                        AO sowie § 257 Abs. 1 Nr. 4 i.V.m. Abs. 4 HGB).</li>
                    <li>6 Jahre - Übrige Geschäftsunterlagen: empfangene Handels- oder Geschäftsbriefe, Wiedergaben der
                        abgesandten
                        Handels- oder Geschäftsbriefe, sonstige Unterlagen, soweit sie für die Besteuerung von Bedeutung sind,
                        z. B.
                        Stundenlohnzettel, Betriebsabrechnungsbögen, Kalkulationsunterlagen, Preisauszeichnungen, aber auch
                        Lohnabrechnungsunterlagen, soweit sie nicht bereits Buchungsbelege sind und Kassenstreifen (§ 147 Abs. 1
                        Nr.
                        2,
                        3, 5 i.V.m. Abs. 3 AO, § 257 Abs. 1 Nr. 2 u. 3 i.V.m. Abs. 4 HGB).</li>
                    <li>3 Jahre - Daten, die erforderlich sind, um potenzielle Gewährleistungs- und Schadensersatzansprüche oder
                        ähnliche vertragliche Ansprüche und Rechte zu berücksichtigen sowie damit verbundene Anfragen zu
                        bearbeiten,
                        basierend auf früheren Geschäftserfahrungen und üblichen Branchenpraktiken, werden für die Dauer der
                        regulären
                        gesetzlichen Verjährungsfrist von drei Jahren gespeichert (§§ 195, 199 BGB).
                    </li>
                </ul>
                <p>Fristbeginn mit Ablauf des Jahres: Beginnt eine Frist nicht ausdrücklich zu einem bestimmten Datum und
                    beträgt
                    sie
                    mindestens ein Jahr, so startet sie automatisch am Ende des Kalenderjahres, in dem das fristauslösende
                    Ereignis
                    eingetreten ist. Im Fall laufender Vertragsverhältnisse, in deren Rahmen Daten gespeichert werden, ist das
                    fristauslösende Ereignis der Zeitpunkt des Wirksamwerdens der Kündigung oder sonstige Beendigung des
                    Rechtsverhältnisses.</p>
            </section>

            <section>
                <h2 className="text-2xl font-semibold mb-2">Bereitstellung des Onlineangebots und Webhosting</h2>
                <p>Wir verarbeiten die Daten der Nutzer, um ihnen unsere Online-Dienste zur Verfügung stellen zu können.
                    Zu diesem Zweck verarbeiten wir die IP-Adresse des Nutzers, die notwendig ist,
                    um die Inhalte und Funktionen unserer Online-Dienste an den Browser oder das Endgerät der Nutzer zu übermitteln.
                </p>
                <br />
                <ul className="m-elements space-y-2">
                    <li>
                        <strong>Verarbeitete Datenarten:</strong>
                        Nutzungsdaten (z. B. Seitenaufrufe und Verweildauer, Klickpfade, Nutzungsintensität und -frequenz,
                        verwendete Gerätetypen und Betriebssysteme, Interaktionen mit Inhalten und Funktionen); Meta-,
                        Kommunikations- und Verfahrensdaten (z. B. IP-Adressen, Zeitangaben,
                        Identifikationsnummern, beteiligte Personen). Protokolldaten (z. B. Logfiles betreffend Logins oder den Abruf von Daten oder Zugriffszeiten.).
                    </li>
                    <li>
                        <strong>Betroffene Personen:</strong>
                        Nutzer (z. B. Webseitenbesucher, Nutzer von Onlinediensten).
                    </li>
                    <li>
                        <strong>Zwecke der Verarbeitung:</strong>
                        Bereitstellung unseres Onlineangebotes und Nutzerfreundlichkeit;
                        Informationstechnische Infrastruktur (Betrieb und Bereitstellung von Informationssystemen und
                        technischen Geräten (Computer, Server etc.)). Sicherheitsmaßnahmen.
                    </li>
                    <li>
                        <strong>Aufbewahrung und Löschung:</strong>
                        Löschung entsprechend Angaben im Abschnitt "Allgemeine Informationen zur Datenspeicherung und Löschung".
                    </li>
                    <li>
                        <strong>Rechtsgrundlagen:</strong> Berechtigte Interessen (Art. 6 Abs. 1 S. 1 lit. f) DSGVO).
                    </li>
                </ul>
                <p>
                    <strong>Weitere Hinweise zu Verarbeitungsprozessen, Verfahren und Diensten:</strong>
                </p>
                <ul className="m-elements space-y-2">
                    <li><strong>Bereitstellung Onlineangebot auf gemietetem Speicherplatz: </strong>Für die Bereitstellung
                        unseres
                        Onlineangebotes nutzen wir Speicherplatz, Rechenkapazität und Software, die wir von einem entsprechenden
                        Serveranbieter (auch "Webhoster" genannt) mieten oder anderweitig beziehen; <span
                            className=""><strong>Rechtsgrundlagen:</strong> Berechtigte Interessen (Art. 6 Abs. 1 S. 1 lit. f)
                            DSGVO).</span></li>
                    <li>
                        <strong>Erhebung von Zugriffsdaten und Logfiles: </strong>
                        Der Zugriff auf unser Onlineangebot wird in Form von sogenannten "Server-Logfiles" protokolliert.
                        Zu den Serverlogfiles können die Adresse und der Name der abgerufenen Webseiten und Dateien,
                        Datum und Uhrzeit des Abrufs, übertragene Datenmengen, Meldung über erfolgreichen Abruf,
                        Browsertyp nebst Version, das Betriebssystem des Nutzers, Referrer URL (die zuvor besuchte Seite)
                        und im Regelfall IP-Adressen und der anfragende Provider gehören. Die Serverlogfiles können zum einen zu
                        Sicherheitszwecken eingesetzt werden,
                        z.B. um eine Überlastung der Server zu vermeiden (insbesondere im Fall von missbräuchlichen Angriffen, sogenannten DDoS-Attacken),
                        und zum anderen, um die Auslastung der Server und ihre Stabilität sicherzustellen;

                        <span>
                            <strong>Rechtsgrundlagen:</strong>
                            Berechtigte Interessen (Art. 6 Abs. 1 S. 1 lit. f) DSGVO).
                        </span>

                        <strong>Löschung von Daten:</strong>
                        Logfile-Informationen werden für die Dauer von maximal 30 Tagen gespeichert und danach gelöscht oder anonymisiert.
                        Daten, deren weitere Aufbewahrung zu Beweiszwecken erforderlich ist, sind bis zur endgültigen Klärung des jeweiligen Vorfalls von der Löschung ausgenommen.
                    </li>
                    <li>
                        <strong>Contabo: </strong>Leistungen auf dem Gebiet der Bereitstellung von informationstechnischer
                        Infrastruktur und verbundenen Dienstleistungen (z.B. Speicherplatz und/oder Rechenkapazitäten);<br />

                        <strong>Dienstanbieter:</strong> Contabo GmbH Welfenstraße 22 81541 München Deutschland<br />

                        <strong>Website:</strong> <a href="https://contabo.com/de/" target="_blank">https://contabo.com/de/</a>;<br />

                        <strong>Datenschutzerklärung:</strong> <a href="https://contabo.com/de/legal/privacy/" target="_blank">https://contabo.com/de/legal/privacy/</a>.<br />

                    </li>
                </ul>
            </section>

            <section>
                <h2 className="text-2xl font-semibold mb-2">Änderung und Aktualisierung</h2>
                <p>Wir bitten Sie, sich regelmäßig über den Inhalt unserer Datenschutzerklärung zu informieren. Wir passen die
                    Datenschutzerklärung an, sobald die Änderungen der von uns durchgeführten Datenverarbeitungen dies
                    erforderlich
                    machen. Wir informieren Sie, sobald durch die Änderungen eine Mitwirkungshandlung Ihrerseits (z. B.
                    Einwilligung)
                    oder eine sonstige individuelle Benachrichtigung erforderlich wird.
                </p>
                <br />
                <p>Sofern wir in dieser Datenschutzerklärung Adressen und Kontaktinformationen von Unternehmen und
                    Organisationen
                    angeben, bitten wir zu beachten, dass die Adressen sich über die Zeit ändern können und bitten die Angaben
                    vor
                    Kontaktaufnahme zu prüfen.
                </p>
            </section>

            <section>
                <h2 className="text-2xl font-semibold mb-2">Begriffsdefinitionen</h2>
                <p>In diesem Abschnitt erhalten Sie eine Übersicht über die in dieser Datenschutzerklärung verwendeten
                    Begrifflichkeiten. Soweit die Begrifflichkeiten gesetzlich definiert sind, gelten deren gesetzliche
                    Definitionen.
                    Die nachfolgenden Erläuterungen sollen dagegen vor allem dem Verständnis dienen.
                </p>
                <br />
                <ul className="glossary space-y-2">
                    <li>
                        <strong>Meta-, Kommunikations- und Verfahrensdaten:</strong>
                        Meta-, Kommunikations- und Verfahrensdaten sind Kategorien, die Informationen über die Art und Weise
                        enthalten, wie Daten verarbeitet, übermittelt und verwaltet werden.
                        Meta-Daten, auch bekannt als Daten über Daten, umfassen Informationen, die den Kontext, die Herkunft und
                        die Struktur anderer Daten beschreiben.
                        Sie können Angaben zur Dateigröße, dem Erstellungsdatum, dem Autor eines Dokuments und den
                        Änderungshistorien beinhalten.
                        Kommunikationsdaten erfassen den Austausch von Informationen zwischen Nutzern über verschiedene Kanäle,
                        wie E-Mail-Verkehr, Anrufprotokolle, Nachrichten in sozialen
                        Netzwerken und Chat-Verläufe, inklusive der beteiligten Personen, Zeitstempel und Übertragungswege.
                        Verfahrensdaten beschreiben die Prozesse und Abläufe innerhalb von Systemen oder Organisationen,
                        einschließlich
                        Workflow-Dokumentationen, Protokolle von Transaktionen und Aktivitäten, sowie Audit-Logs, die zur
                        Nachverfolgung
                        und Überprüfung von Vorgängen verwendet werden.
                    </li>
                    <li>
                        <strong>Nutzungsdaten:</strong>
                        Nutzungsdaten beziehen sich auf Informationen, die erfassen, wie Nutzer mit digitalen Produkten,
                        Dienstleistungen oder Plattformen interagieren.
                        Diese Daten umfassen eine breite Palette von Informationen, die aufzeigen, wie Nutzer Anwendungen
                        nutzen, welche Funktionen sie bevorzugen,
                        wie lange sie auf bestimmten Seiten verweilen und über welche Pfade sie durch eine Anwendung navigieren.
                        Nutzungsdaten können auch die Häufigkeit der Nutzung, Zeitstempel von Aktivitäten, IP-Adressen,
                        Geräteinformationen und Standortdaten einschließen.
                        Sie sind besonders wertvoll für die Analyse des Nutzerverhaltens, die Optimierung von
                        Benutzererfahrungen, das Personalisieren von Inhalten und das Verbessern von Produkten oder
                        Dienstleistungen.
                        Darüber hinaus spielen Nutzungsdaten eine entscheidende Rolle beim Erkennen von Trends, Vorlieben und
                        möglichen Problembereichen innerhalb digitaler Angebote
                    </li>
                    <li>
                        <strong>Personenbezogene Daten:</strong>
                        "Personenbezogene Daten" sind alle Informationen, die sich auf eine identifizierte oder identifizierbare
                        natürliche Person (im Folgenden "betroffene Person") beziehen; als identifizierbar wird eine natürliche
                        Person angesehen,
                        die direkt oder indirekt, insbesondere mittels Zuordnung zu einer Kennung wie einem Namen, zu einer
                        Kennnummer,
                        zu Standortdaten, zu einer Online-Kennung (z. B.Cookie) oder zu einem oder mehreren besonderen Merkmalen
                        identifiziert werden kann,
                        die Ausdruck der physischen, physiologischen, genetischen, psychischen, wirtschaftlichen, kulturellen
                        oder sozialen Identität dieser
                        natürlichen Person sind.
                    </li>
                    <li>
                        <strong>Protokolldaten:</strong>
                        Protokolldaten sind Informationen über Ereignisse oder Aktivitäten, die in einem System oder Netzwerk
                        protokolliert wurden.
                        Diese Daten enthalten typischerweise Informationen wie Zeitstempel, IP-Adressen, Benutzeraktionen,
                        Fehlermeldungen und andere Details über die Nutzung oder den Betrieb eines Systems.
                        Protokolldaten werden oft zur Analyse von Systemproblemen, zur Sicherheitsüberwachung oder zur
                        Erstellung von Leistungsberichten verwendet.
                    </li>

                    <li>
                        <strong>Verantwortlicher:</strong>
                        Als "Verantwortlicher" wird die natürliche oder juristische Person, Behörde, Einrichtung oder andere
                        Stelle,
                        die allein oder gemeinsam mit anderen über die Zwecke und Mittel der Verarbeitung von personenbezogenen
                        Daten entscheidet, bezeichnet.
                    </li>

                    <li>
                        <strong>Verarbeitung:</strong>
                        "Verarbeitung" ist jeder mit oder ohne Hilfe automatisierter Verfahren ausgeführte Vorgang oder jede
                        solche Vorgangsreihe im Zusammenhang mit personenbezogenen Daten.
                        Der Begriff reicht weit und umfasst praktisch jeden Umgang mit Daten, sei es das Erheben, das Auswerten,
                        das Speichern, das Übermitteln oder das Löschen.
                    </li>
                </ul>
            </section>
            <section>
                <p className="seal">
                    <a href="https://datenschutz-generator.de/"
                        title="Rechtstext von Dr. Schwenke - für weitere Informationen bitte anklicken." target="_blank"
                        rel="noopener noreferrer nofollow">
                        Erstellt mit kostenlosem Datenschutz-Generator.de von Dr. Thomas Schwenke
                    </a>
                </p>
            </section>
        </div>
    );
}

export default Datenschutz;